import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { getAdminHeaders, getAdminUrl, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import { adminContentUpdate, contentList, shopWithPurposeBgImageAdd } from 'shared/settings/apiconfig';
import './MysteryRewards.scss';

export const MysteryRewards = (props) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfName, setPdfName] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [mysteryMsg, setMysteryMsg] = useState({ show: false, type: "", msg: "" });
    const [premierData, setPremierData] = useState(null);
    const [base64, setBase64] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [noDataMsg, setNoDataMsg] = useState(false);
    const [uploadError, setUploadError] = useState({ show: false, type: "", msg: "" })

    useEffect(() => {
        setPageLoading(true);
        getContentList();
    }, [])
    
    const getContentList = () => {
        setNoDataMsg(false);
        let data = {
            "filter": [
                { "field": "status", "value": "Active", "op": "=", "join": "AND" },
                { "field": "screenname", "value": "YourPremierBenefits", "op": "=", "join": "AND" },
                { "field": "contenttype", "value": "JSON", "op": "=", "join": "AND" }
            ]
        }

        axios.post(getBuyerUrl(`${contentList}`), data, getBuyerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                let responseData = response.data.data[0];
                setPremierData(responseData);
                let data = JSON.parse(responseData.jsoncontent);
                let index = data.body.findIndex(elem => elem.title == "Mystery Rewards");

                if (index !== -1) {
                    let mysteryData = data.body[index].description.split("#");
                    setPdfUrl(mysteryData[2]);
                }
                setPageLoading(false);
            }
        }).catch(error => {
            setPageLoading(false);
            setNoDataMsg(true);
        });
    }

    const handleFileChange = (event) => {
        setUploadLoading(true);
        setMysteryMsg({ show: false, type: "", msg: "" });
        let reader = new FileReader();

        const file = event.target.files[0];
        setPdfName(file.name);

        reader.readAsDataURL(file);
        if (file && file.type === 'application/pdf') {

            reader.onload = function () {
                const base64String = reader.result.split(',')[1];
                setBase64(base64String);
                setFileData(file);
                setUploadLoading(false);
            };
        } else {
            setUploadLoading(false);
            setMysteryMsg({ show: true, type: "error", msg: "Please upload a valid PDF file." });
        }
    };

    // const onclickPDF = () => {
    //     if (pdfUrl) {
    //         window.open(pdfUrl, '_blank');
    //     }
    // };

    const cancelUpload = () => {
        setUploadLoading(false);
        setMysteryMsg({ show: false, type: "", msg: "" });
        setLoading(false);
        setPdfUrl(null);
        setPdfName(null);     
    }

    const uploadFile = () => {
        setUploadLoading(true);
        let payload = {
            url: base64,
            type: fileData.type === 'application/pdf' ? 'pdf' : 'image'
        }

        axios.post(getAdminUrl(shopWithPurposeBgImageAdd), JSON.stringify({ data: payload }), getAdminHeaders()).then(response => {
            if (response.data.status == "success") {
                setUploadLoading(false);
                setPdfUrl(response.data.data);
            }
        }).catch(error => {
            setUploadLoading(false);
            setUploadError({ show: true, type: "error", msg: error.response.data.message })
        })
    }

    const saveMystery = () => {
        setLoading(true);
        let data = JSON.parse(premierData.jsoncontent);
        let index = data.body.findIndex(elem => elem.title == "Mystery Rewards");

        if (index !== -1) {
            let mysteryData = data.body[index].description.split("#");
            mysteryData[2] = pdfUrl;
            data.body[index].description = mysteryData.join("#");
            premierData.jsoncontent = JSON.stringify(data);
            setPremierData(premierData.jsoncontent);
        }
        axios.put(getAdminUrl(`${adminContentUpdate}`), {data: premierData}, getAdminHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                setLoading(false);
                setPremierData(null);
                setMysteryMsg({ show: true, type: "success", msg:'Mystery rewards document is uploaded successfully'});
                setTimeout(() => {
                    setMysteryMsg({ show: false, type: "", msg: "" })
                }, 5000);
            }
        }).catch(error => {
            if(error) {
                setLoading(false);
                setMysteryMsg({ show: true, type: "error", msg: error.response.data.message });
                setTimeout(() => {
                    setMysteryMsg({ show: false, type: "", msg: "" })
                }, 5000);
            }  
        });

    }

    const cancelMystery = () => {
        props.history.goBack();
    }

    return (
        <div className="mystery-reward h-100 p-5 pd-resp" style={{ overflowY: "scroll" }}>
            { pageLoading ? 
            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
            </div> : noDataMsg ? 
            <div className='d-flex h-100 align-items-center justify-content-center'>
                No Data Found
            </div> : 
            <div>
                <h3 className='font-weight-bold'>Mystery Rewards</h3>
                <h5 className='mt-5 font-weight-bold'>Drawing Rules</h5>
                <div className='mt-5 d-flex justify-content-center'>
                    <div className="d-flex flex-column align-items-center justify-content-center clickable wd-50 reward-resp" style={{ border: "none", padding: "3%", borderRadius: "5px", boxShadow: "5px 5px 15px 5px #e7e7e7" }}>
                    <h4 className='font-weight-bold'>Upload Files</h4>

                    {
                        pdfUrl ? 
                            <div className='mt-3'>{pdfUrl}</div> : 
                            pdfName ? 
                            <div className='mt-3' style={{ wordBreak: "break-word" }}>{pdfName}</div> :
                            <>
                                <label htmlFor="pdf-upload" className="d-flex flex-column align-items-center justify-content-center p-3 mt-3 clickable"
                                style={{ border: "2px dashed grey", cursor: "pointer", width: "100%", textAlign: "center", borderRadius: "5px" }}>
                                    <img src={`${process.env.PUBLIC_URL}/static/images/upload.png`} alt="default" height="75" width="75" />
                                    <div className="d-flex flex-column">
                                        <h5>Drop files here</h5>
                                        <h6>Supported format: PDF</h6>
                                    </div>
                                    <div className='font-weight-bold'>OR</div>
                                    <div style={{ color: "blue" }}>Browse a files</div>
                                </label>
                                <input type="file" accept="application/pdf" id="pdf-upload" style={{ display: "none" }} onChange={handleFileChange} />
                            </> 
                    }
                    <div className="d-flex align-items-center justify-content-between mt-3">
                        {/* { pdfName ? <Button className='d-flex align-items-center justify-content-center' onClick={() => {onclickPDF()}}  disabled={mysteryMsg.type == "error"}>Preview</Button> : ''} */}
                        { pdfUrl ? <Button onClick={() => {cancelUpload()}} style={{ marginLeft: "10px" }} disabled={mysteryMsg.type == "error"}>Cancel</Button> : ''}
                        { !pdfUrl ? <Button onClick={() => {uploadFile()}} style={{ marginLeft: "10px" }} disabled={mysteryMsg.msg || loading || uploadLoading || !pdfName}>Upload {loading || uploadLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }</Button> : '' }
                    </div>
                </div>
                </div> 
                
                {uploadError.show ? <div className='d-flex align-items-center justify-content-center font-weight-bold mt-3' style={{ color: "red" }}>{uploadError.msg}</div> : ''}

                { mysteryMsg.show ? <div className='d-flex align-items-center justify-content-center mt-5 font-weight-bold' style={{ color: mysteryMsg.type === "success" ? "green" : mysteryMsg.type === "error" ? "red" : "" }}>{mysteryMsg.msg}</div> : '' }

                <div className="d-flex align-items-center justify-content-center mt-5">
                    <Button onClick={() => {cancelMystery()}} style={{ marginLeft: "10px" }} disabled={mysteryMsg.type == "error"}>Cancel</Button>
                    <Button className='btn-secondary' onClick={() => {saveMystery()}} style={{ marginLeft: "10px" }} disabled={!pdfName || !pdfUrl || loading}>Save 
                        {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }
                        </Button>
                </div>
            </div> }
        </div>
    )
}
export default MysteryRewards;
